import React, { Component } from "react"
import TableUnidades from "./TableUnidades"
import Layout from "../Layout"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
export default class UnidadesOrcamentarias extends Component {
  constructor() {
    super()
    this.getUnidades = this.getUnidades.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { unidades: [], showTable: false }
  }
  componentWillMount() {
    this.getUnidades()
  }
  getUnidades() {
    ApiHelper.getUnidadesOrcametarias((unidades, error) => {
      if (unidades) {
        this.setState({
          unidades: unidades,
          initialUnidades: unidades,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialUnidades.filter(unidade => {
      return (
        unidade.uni_orc.toLowerCase().search(searchText) !== -1 ||
        unidade.cod_uni_orc.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      unidades: filtered
    })
  }
  didDelete() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Unidades orçamentárias">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Unidades orçamentárias">
        {this.state.showTable ? (
          <TableUnidades
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title={"Unidades Orçamentárias"}
            subtitle={"Listagem de todas as unidades orçamentárias"}
            backgroundColor="as-blue"
            rows={this.state.unidades}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/UnidadesOrcamentarias.js